import AddressbarColor from 'quasar/src/plugins/addressbar/AddressbarColor.js';
import { defineBoot } from '#q-app/wrappers';
export default defineBoot(() => {
    AddressbarColor.set('#008DB9');
});
